(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function updateCartLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) { console.error('Cart update failed:', err); });
    }

    document.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.name;
        var input = document.querySelector('input[name="' + name + '"]');
        if (!input) return;
        var val = parseInt(input.value, 10);
        if (btn.dataset.action === 'increase') val = val + 1;
        else if (val > 0) val = val - 1;
        input.value = val;

        var match = name.match(/updates\[(.+)\]/);
        var key = match ? match[1] : null;
        if (key) updateCartLine(key, val);
      });
    });

    document.querySelectorAll('.cart-item__qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var match = input.name.match(/updates\[(.+)\]/);
        var key = match ? match[1] : null;
        var val = parseInt(input.value, 10) || 0;
        if (key) updateCartLine(key, val);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    /* ── Qty-stepper helpers ── */
    function updateCartBadge(cart) {
      var badge = document.getElementById('cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    }

    function createStepper(variantId, qty) {
      var div = document.createElement('div');
      div.className = 'qty-stepper';
      div.dataset.variantId = variantId;
      div.innerHTML =
        '<button class="qty-stepper__btn qty-stepper__btn--minus" aria-label="Remove one">−</button>' +
        '<span class="qty-stepper__count">' + qty + '</span>' +
        '<button class="qty-stepper__btn qty-stepper__btn--plus" aria-label="Add one">+</button>';
      return div;
    }

    function showStepper(form, variantId, qty) {
      if (!form || !form.parentNode) return;
      var btn = form.querySelector('.pcard__atc, .product-card__atc');
      var existing = form.parentNode.querySelector('.qty-stepper[data-variant-id="' + variantId + '"]');
      if (existing) {
        existing.querySelector('.qty-stepper__count').textContent = qty;
        return;
      }
      if (btn) btn.style.display = 'none';
      var stepper = createStepper(variantId, qty);
      form.parentNode.insertBefore(stepper, form.nextSibling);
      bindStepper(stepper, form);
    }

    function hideStepper(form, variantId) {
      if (!form || !form.parentNode) return;
      var btn = form.querySelector('.pcard__atc, .product-card__atc');
      var stepper = form.parentNode.querySelector('.qty-stepper[data-variant-id="' + variantId + '"]');
      if (stepper) stepper.remove();
      if (btn) { btn.style.display = ''; btn.disabled = false; btn.textContent = 'Add to Cart'; }
    }

    function changeQty(variantId, newQty, stepper, form) {
      stepper.querySelectorAll('.qty-stepper__btn').forEach(function(b) { b.disabled = true; });
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: newQty })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartBadge(cart);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          var found = false;
          cart.items.forEach(function(item) {
            if (item.variant_id == variantId) {
              stepper.querySelector('.qty-stepper__count').textContent = item.quantity;
              found = true;
            }
          });
          if (!found) hideStepper(form, variantId);
        })
        .catch(function() { console.error('Cart update failed'); })
        .finally(function() {
          stepper.querySelectorAll('.qty-stepper__btn').forEach(function(b) { b.disabled = false; });
        });
    }

    function bindStepper(stepper, form) {
      var variantId = stepper.dataset.variantId;
      stepper.querySelector('.qty-stepper__btn--plus').addEventListener('click', function() {
        var count = parseInt(stepper.querySelector('.qty-stepper__count').textContent, 10) || 0;
        changeQty(variantId, count + 1, stepper, form);
      });
      stepper.querySelector('.qty-stepper__btn--minus').addEventListener('click', function() {
        var count = parseInt(stepper.querySelector('.qty-stepper__count').textContent, 10) || 0;
        changeQty(variantId, count - 1, stepper, form);
      });
    }

    /* ── Add-to-cart AJAX ── */
    document.querySelectorAll('.product-card__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('.product-card__atc');
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var variantId = idField ? idField.value : null;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qtyField ? (parseInt(qtyField.value, 10) || 1) : 1 })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw new Error(err.description || 'Unable to add to cart'); });
            return response.json();
          })
          .then(function () {
            if (button) button.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            fetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                updateCartBadge(cart);
                cart.items.forEach(function(item) {
                  if (item.variant_id == variantId) showStepper(form, variantId, item.quantity);
                });
              });
          })
          .catch(function (error) {
            if (button) { button.textContent = 'Try Again'; button.disabled = false; }
            console.error('Add to cart failed:', error);
          })
          .finally(function () {
            setTimeout(function () {
              if (button && button.style.display !== 'none') { button.disabled = false; button.textContent = 'Add to Cart'; }
            }, 1500);
          });
      });
    });

    /* ── Page-load: show steppers for items already in cart ── */
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cart.items.forEach(function(item) {
          document.querySelectorAll('.pcard__form, .product-card__form').forEach(function(form) {
            var idField = form.querySelector('[name="id"]');
            if (idField && idField.value == item.variant_id) {
              showStepper(form, String(item.variant_id), item.quantity);
            }
          });
        });
      })
      .catch(function() {});

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    /* ── Tab filtering ── */
    var tabs = document.querySelectorAll('.fp-tab');
    var cards = document.querySelectorAll('.pcard');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var filter = tab.dataset.fpTab;
        cards.forEach(function (card) {
          card.style.display = (filter === 'all' || card.dataset.fpCategory === filter) ? '' : 'none';
        });
      });
    });

    /* ── Qty-stepper helpers ── */
    function updateCartBadge(cart) {
      var badge = document.getElementById('cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    }

    function createStepper(variantId, qty) {
      var div = document.createElement('div');
      div.className = 'qty-stepper';
      div.dataset.variantId = variantId;
      div.innerHTML =
        '<button class="qty-stepper__btn qty-stepper__btn--minus" aria-label="Remove one">−</button>' +
        '<span class="qty-stepper__count">' + qty + '</span>' +
        '<button class="qty-stepper__btn qty-stepper__btn--plus" aria-label="Add one">+</button>';
      return div;
    }

    function showStepper(form, variantId, qty) {
      if (!form || !form.parentNode) return;
      var btn = form.querySelector('.pcard__atc, .product-card__atc');
      var existing = form.parentNode.querySelector('.qty-stepper[data-variant-id="' + variantId + '"]');
      if (existing) {
        existing.querySelector('.qty-stepper__count').textContent = qty;
        return;
      }
      if (btn) btn.style.display = 'none';
      var stepper = createStepper(variantId, qty);
      form.parentNode.insertBefore(stepper, form.nextSibling);
      bindStepper(stepper, form, btn);
    }

    function hideStepper(form, variantId) {
      if (!form || !form.parentNode) return;
      var btn = form.querySelector('.pcard__atc, .product-card__atc');
      var stepper = form.parentNode.querySelector('.qty-stepper[data-variant-id="' + variantId + '"]');
      if (stepper) stepper.remove();
      if (btn) { btn.style.display = ''; btn.disabled = false; btn.textContent = 'Add to Cart'; }
    }

    function changeQty(variantId, newQty, stepper, form) {
      stepper.querySelectorAll('.qty-stepper__btn').forEach(function(b) { b.disabled = true; });
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: newQty })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartBadge(cart);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          var found = false;
          cart.items.forEach(function(item) {
            if (item.variant_id == variantId) {
              stepper.querySelector('.qty-stepper__count').textContent = item.quantity;
              found = true;
            }
          });
          if (!found) hideStepper(form, variantId);
        })
        .catch(function() { console.error('Cart update failed'); })
        .finally(function() {
          stepper.querySelectorAll('.qty-stepper__btn').forEach(function(b) { b.disabled = false; });
        });
    }

    function bindStepper(stepper, form) {
      var variantId = stepper.dataset.variantId;
      stepper.querySelector('.qty-stepper__btn--plus').addEventListener('click', function() {
        var count = parseInt(stepper.querySelector('.qty-stepper__count').textContent, 10) || 0;
        changeQty(variantId, count + 1, stepper, form);
      });
      stepper.querySelector('.qty-stepper__btn--minus').addEventListener('click', function() {
        var count = parseInt(stepper.querySelector('.qty-stepper__count').textContent, 10) || 0;
        changeQty(variantId, count - 1, stepper, form);
      });
    }

    /* ── Add-to-cart AJAX ── */
    document.querySelectorAll('.pcard__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('.pcard__atc');
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var variantId = idField ? idField.value : null;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qtyField ? (parseInt(qtyField.value, 10) || 1) : 1 })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw new Error(err.description || 'Unable to add to cart'); });
            return response.json();
          })
          .then(function () {
            if (button) button.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            fetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                updateCartBadge(cart);
                cart.items.forEach(function(item) {
                  if (item.variant_id == variantId) showStepper(form, variantId, item.quantity);
                });
              });
          })
          .catch(function (error) {
            if (button) { button.textContent = 'Try Again'; button.disabled = false; }
            console.error('Add to cart failed:', error);
          })
          .finally(function () {
            setTimeout(function () {
              if (button && button.style.display !== 'none') { button.disabled = false; button.textContent = 'Add to Cart'; }
            }, 1500);
          });
      });
    });

    /* ── Page-load: show steppers for items already in cart ── */
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cart.items.forEach(function(item) {
          document.querySelectorAll('.pcard__form, .product-card__form').forEach(function(form) {
            var idField = form.querySelector('[name="id"]');
            if (idField && idField.value == item.variant_id) {
              showStepper(form, String(item.variant_id), item.quantity);
            }
          });
        });
      })
      .catch(function() {});

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.getElementById('site-header');
    const hamburger = header.querySelector('.site-header__hamburger');
    const mobileNav = document.getElementById('mobile-nav');

    const observer = new IntersectionObserver(
      ([entry]) => header.classList.toggle('is-sticky', !entry.isIntersecting),
      { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
    );
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none';
    document.body.prepend(sentinel);
    observer.observe(sentinel);

    hamburger.addEventListener('click', () => {
      const open = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.setAttribute('aria-expanded', String(!open));
      hamburger.classList.toggle('is-open', !open);
      mobileNav.hidden = open;
    });
  })();

  // Account dropdown
  (function () {
    const dropdown = document.getElementById('acct-dropdown');
    if (!dropdown) return;
    const trigger = dropdown.querySelector('.acct-dropdown__trigger');
    const popup = document.getElementById('acct-popup');
    const continueBtn = document.getElementById('acct-continue');

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!open));
      popup.hidden = open;
    });

    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        trigger.setAttribute('aria-expanded', 'false');
        popup.hidden = true;
      }
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        const email = document.getElementById('acct-email').value.trim();
        const url = '/account/login' + (email ? '?email=' + encodeURIComponent(email) : '');
        window.location.href = url;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Gallery thumbs
    const mainImg = document.querySelector('.product-gallery__main-img img');
    const thumbs = document.querySelectorAll('.product-gallery__thumb');

    function goToThumb(index) {
      const total = thumbs.length;
      const i = (index + total) % total;
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumbs[i].classList.add('is-active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = thumbs[i].dataset.src;
          mainImg.srcset = '';
          mainImg.style.opacity = '1';
        }, 180);
      }
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => goToThumb(index));
    });

    // Arrow navigation
    const prevBtn = document.querySelector('.gallery-arrow--prev');
    const nextBtn = document.querySelector('.gallery-arrow--next');

    if (prevBtn && nextBtn && thumbs.length > 0) {
      prevBtn.addEventListener('click', () => {
        const active = Array.from(thumbs).findIndex(t => t.classList.contains('is-active'));
        goToThumb(active - 1);
      });
      nextBtn.addEventListener('click', () => {
        const active = Array.from(thumbs).findIndex(t => t.classList.contains('is-active'));
        goToThumb(active + 1);
      });
    }

    // Quantity
    const qtyInput = document.querySelector('.product-form__qty-input');
    document.querySelectorAll('.product-form__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const val = parseInt(qtyInput.value, 10);
        if (btn.dataset.action === 'increase') qtyInput.value = val + 1;
        else if (val > 1) qtyInput.value = val - 1;
      });
    });

    // AJAX add to cart
    const productForm = document.querySelector('.product-form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const button = productForm.querySelector('.product-form__atc');
        if (button && button.disabled) return;

        const originalText = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }

        const idField = productForm.querySelector('[name="id"]');
        const qtyField = qtyInput || productForm.querySelector('[name="quantity"]');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: idField ? idField.value : null,
            quantity: qtyField ? (parseInt(qtyField.value, 10) || 1) : 1
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (err) {
                throw new Error(err.description || 'Unable to add to cart');
              });
            }
            return response.json();
          })
          .then(function () {
            if (button) button.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          })
          .catch(function (error) {
            if (button) button.textContent = 'Try Again';
            console.error('Add to cart failed:', error);
          })
          .finally(function () {
            setTimeout(function () {
              if (button) {
                button.disabled = false;
                button.textContent = originalText;
              }
            }, 1500);
          });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
